var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNextButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.653,
    height: 76.653,
    viewBox: "0 0 76.653 76.653",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1684 -2511.159)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38.327,
    cy: 38.327,
    r: 38.327,
    transform: "translate(1760.653 2511.159) rotate(90)",
    fill: "#ef1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.312,171.139c.021-.025.038-.051.058-.077s.044-.057.064-.087.038-.062.057-.094.034-.054.049-.082.031-.064.047-.1.029-.058.041-.089.024-.064.035-.1.024-.064.034-.1.017-.064.025-.1.018-.068.025-.1.012-.075.017-.112.01-.06.013-.09a2.1,2.1,0,0,0,0-.413c0-.032-.009-.062-.014-.094s-.009-.073-.017-.109-.017-.071-.026-.106-.014-.062-.024-.092-.023-.068-.036-.1-.021-.061-.033-.091-.029-.063-.043-.094-.028-.062-.044-.092-.035-.059-.052-.088-.034-.059-.053-.087-.047-.064-.07-.1-.033-.047-.052-.069a2.092,2.092,0,0,0-.15-.164l-.009-.01-7.411-7.411a2.093,2.093,0,1,0-2.96,2.96l5.846,5.941-5.825,5.941a2.093,2.093,0,1,0,2.96,2.96l7.411-7.411,0-.005Q546.249,171.216,546.312,171.139Z",
    transform: "translate(1182.349 2379.684)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextButton);
export default __webpack_public_path__ + "static/media/next-button.06d0ef2425d466931e40d61818152c5b.svg";
export { ForwardRef as ReactComponent };